import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const EmptySidebarCollapsibleSectionLoader: LoadableType<{
	children: React.ReactNode;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EmptySidebarCollapsibleSectionContainer" */ '../src/CollapsibleSection.tsx'
			)
		).EmptySidebarCollapsibleSectionContainerWrapper,
});
